"use client";

import { CookieConsentProvider } from "@/contexts/CookieConsentContext";
import { CookieConsentBanner } from "@/components/CookieConsentBanner";
import { PwaInstallBanner } from "@/components/PwaInstallBanner";

export function CookieConsentProviderClient({ children }: { children: React.ReactNode }) {
  return (
    <CookieConsentProvider>
      {children}
      <CookieConsentBanner />
      <PwaInstallBanner />
    </CookieConsentProvider>
  );
}
